import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AttachmentTileImageWrapper = styled.figure`
  height: 100%;
  position: relative;
  overflow: hidden;
  cursor: pointer;
`

interface AttachmentTileImageProps {
  loading: boolean
}

export const AttachmentTilePreviewWrapper = styled('div', {
  shouldForwardProp: (propName) => propName !== 'loading',
})<AttachmentTileImageProps>`
  height: 100%;

  ${({ loading }) =>
    loading &&
    `
    opacity: 0;
    width: 100%;
    position: absolute;
  `}
`

export const AttachmentHoverOverlay = styled.div`
  display: flex;
  opacity: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${Color.Grey100}80;
  backdrop-filter: blur(3px);
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`

export const AttachmentTileThumbnailBadge = styled.div`
  position: absolute;
  top: ${Spacing.S8};
  left: ${Spacing.S8};
  z-index: 1;
`
